import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const getMergeSuggestionsForGroup = {
  name: "getMergeSuggestionsForGroup" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ groups: z.array(FulfillmentGroupDataSchema) }),
};
